import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadApplicationDevelopmentPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'アプリ開発 アプリケーション開発 要件定義 予算 ベンダー 資料 ダウンロード ホワイトペーパー'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/application-development/done/'}
          title="ご入力いただきありがとうございます | アプリ開発 発注前チェックリスト | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
